export default {
  'calander.guide': 'Kalenderführer',
  'calander.redtheme': 'Rote Farbe',
  'calander.graytheme': 'Graue Farbe',
  'calander.greentheme': 'Grüne Farbe',
  'calander.bluetheme': 'Blaue Farbe',
  'calander.guidetitle':
    'Die Farben der Anlässe unter dem Kalender sind wie folgt.',
  'calander.redthemeguide':
    'Diese Farbe zeigt offizielle Feiertage gemäß dem ausgewählten Land an.',
  'calander.graythemeguide':
    'Diese Farbe zeigt die religiösen Anlässe des ausgewählten Landes an.',
  'calander.greenthemeguide':
    'Diese Farbe zeigt die einheimischen Anlässe des ausgewählten Landes an.',
  'calander.bluethemeguide':
    'Diese Farbe zeigt die traditionellen lokalen Anlässe des ausgewählten Landes an.',
  'calander.selectCountry': 'Ländername zur Anzeige von Ereignissen',
  'calander.changeDate': 'Datum ändern',
  'calander.changeType': 'Typ ändern',
  'calander.shamsi': 'Shamsi',
  'calander.miladi': 'Miladi',
  'calander.hijri': 'Hijri',
  'otheroption.otheroptions': 'Andere Optionen',
  'calendar.calculateDate': 'Datumsberechnungen',
  'otheroption.departuredate': 'Abreise Datum',
  'otheroption.returndate': 'Rückkehr Datum',
  'otheroption.dayscount': 'Tagzahl',
  'otheroption.calculate': 'Berechnen',
  'otheroption.timeinterval': 'Zeitintervall (Alter)',
  'otheroption.alertinsertresult.de': 'Das eingegebene Datum ist ungültig.',
  'otheroption.untiltodayfuture': 'Zeit ab heute verbleibend.',
  'otheroption.untiltodaypast': 'Zeit bis heute vergangen.',
  'otheroption.otheroptionsguide1':
    'Durch Auswahl eines Landes oben im Kalender werden länderspezifische Ereignisse auf dem Kalender festgelegt.',
  'otheroption.otheroptionsguide2':
    'Wenn Sie den Mauszeiger über einen Tag bewegen, werden alle Ereignisse für diesen Tag unten im Kalender angezeigt.',
  'otheroption.otheroptionsguide3':
    'Durch Klicken auf zwei Daten wird das Zeitintervall zwischen ihnen angezeigt.',
  'otheroption.otheroptionsguide4':
    'Alle Ereignisse des Kalenders werden als Liste im Ereignisabschnitt des Kalenders angezeigt.',
};
